import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)(({ theme }) => ({
	'& .MuiOutlinedInput-root': {
		borderRadius: '8px',
		height: 'auto',
	},
	'& .MuiInputBase-inputMultiline': {
		resize: 'none',
		padding: 0,
	},
	'& .MuiFormHelperText-root': {
		...theme.typography.l1,
		color: theme.palette?.solutions?.[600],
		marginRight: 0,
	},
}));
